export function extractModelFields(elements = []) {
    const fields = [];
    const seen = new Set();

    elements.forEach((el) => {
        if (el.fixed) return;
        if (!el.fieldName) return;
        const name = String(el.fieldName).trim();
        if (!name || seen.has(name)) return;
        seen.add(name);
        fields.push({
            name,
            type: el.type === "image" ? "image" : "text",
            elementId: el.id,
            fixed: false,
        });
    });

    return fields;
}

export function instantiateDesignFromModel(model, values = {}) {
    const safeModel = model || {};
    const elements = JSON.parse(JSON.stringify(safeModel.elements || []));

    const filledElements = elements.map((el) => {
        if (el.fixed) return el;
        const key = el.fieldName ? String(el.fieldName).trim() : "";
        if (!key || !(key in values)) return el;

        if (el.type === "text") {
            return { ...el, text: String(values[key] ?? "") };
        }
        if (el.type === "image") {
            return { ...el, src: String(values[key] ?? "") };
        }
        return el;
    });

    return {
        title: `${safeModel.title || "Design"} - généré`,
        canvasSize: safeModel.canvasSize || { width: 1080, height: 1080 },
        canvasBg: safeModel.canvasBg || "#ffffff",
        elements: filledElements,
    };
}
